import { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import useAgroTechnicalEventsStore from '../store/useAgroTechnicalEventsStore';

export const useProjectContours = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const month = searchParams.get('month') as string;

  const {
    agroTechnicalEventProjectContours,
    fetchAgroTechnicalEventProjectContours,
    agroTechnicalEventProjectContoursLoading,
  } = useAgroTechnicalEventsStore();

  useEffect(() => {
    fetchAgroTechnicalEventProjectContours({ id: id!, month });
  }, [id, month]);

  return {
    data: agroTechnicalEventProjectContours,
    isLoading: agroTechnicalEventProjectContoursLoading,
  };
};
